import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const DATE_FORMAT = 'YYYY-MM-DD';
const TIME_FORMAT = 'HH:mm';

/** Parse an ISO-ish string into a dayjs, or undefined if empty/invalid. */
export function toDayjs(value?: string | null, format: string = DATE_FORMAT): Dayjs | undefined {
  if (!value) return undefined;
  const parsed = dayjs(value, format, true);
  return parsed.isValid() ? parsed : undefined;
}

/** Format a dayjs to an ISO date ('YYYY-MM-DD'), or undefined. */
export function fromDate(value?: Dayjs | null): string | undefined {
  return value && value.isValid() ? value.format(DATE_FORMAT) : undefined;
}

/** Format a dayjs to 'HH:mm', or undefined. */
export function fromTime(value?: Dayjs | null): string | undefined {
  return value && value.isValid() ? value.format(TIME_FORMAT) : undefined;
}

/** Parse a [start, end] ISO tuple into a dayjs tuple, or null. */
export function toDayjsRange(value?: [string, string] | null): [Dayjs, Dayjs] | null {
  if (!value) return null;
  const [start, end] = value;
  const parsedStart = toDayjs(start);
  const parsedEnd = toDayjs(end);
  return parsedStart && parsedEnd ? [parsedStart, parsedEnd] : null;
}

/** Format a dayjs tuple to an ISO [start, end] tuple, or null. */
export function fromDateRange(
  value?: [Dayjs | null, Dayjs | null] | null,
): [string, string] | null {
  if (!value) return null;
  const start = fromDate(value[0]);
  const end = fromDate(value[1]);
  return start && end ? [start, end] : null;
}
